import { AppThunk } from '../../../../../store/types';
import { AuthUserEffects } from '../../../../../effects/authUserEffects';
import { LoginPopupSelectors } from '../../../../../store/loginPopup/selectors';

export class DailyGoalUnauthEvents {

	public static onClick(): AppThunk {
		return async (
			dispatch,
			getState
		): Promise<boolean> => {
			const result = await AuthUserEffects.loginProcess(AuthUserEffects.newUserDefaultHandler, '', '', true);
			const ret = !!result && !!result.authUser;
			if (ret) {
				if (!result.authUser.isNew) {
					const { onLogin } = LoginPopupSelectors.getLoginPopup(getState());
					if (onLogin) {
						onLogin();
					} else {
						window.location.reload();
					}
				}
			}
			return ret;
		}
	}

}